import type { QRConfig } from '@/types/qrCode';

export const FG_PRESETS = [
  { label: 'HT Green', color: '#8FB560' },
  { label: 'White', color: '#FFFFFF' },
  { label: 'Black', color: '#111111' },
];

export const BG_PRESETS = [
  { label: 'Dark', color: '#111111' },
  { label: 'White', color: '#FFFFFF' },
  { label: 'Black', color: '#000000' },
];

export const DOT_STYLES: { value: NonNullable<QRConfig['dotStyle']>; label: string }[] = [
  { value: 'square', label: 'Square' },
  { value: 'dots', label: 'Dots' },
  { value: 'rounded', label: 'Rounded' },
  { value: 'classy', label: 'Classy' },
  { value: 'classy-rounded', label: 'Classy Rnd' },
  { value: 'extra-rounded', label: 'Extra Rnd' },
];

/** Matches admin `qr-logos` API allowlist */
export const QR_LOGO_ALLOWED_MIME_TYPES = [
  'image/png',
  'image/jpeg',
  'image/svg+xml',
  'image/webp',
] as const;

export function isAllowedLogoMimeType(type: string): boolean {
  return (QR_LOGO_ALLOWED_MIME_TYPES as readonly string[]).includes(type);
}
